(ns practitest.frontend.components.view-editor.subs
  (:require
    [clojure.string :as str]
    [practitest.frontend.components.view-editor.basic-builder :as bb]
    [re-frame.core :as re-frame]))

;; TODO: re-frame 1.3.0+ adds :-> shorthand

;; ---- subs ----

(re-frame/reg-sub ::state (fn [db _] (:view-editor db)))
(re-frame/reg-sub ::open? :<- [::state] (fn [s _] (boolean (:open? s))))
(re-frame/reg-sub ::mode :<- [::state] (fn [s _] (:mode s)))
(re-frame/reg-sub ::entity-type :<- [::state] (fn [s _] (:entity-type s)))
(re-frame/reg-sub ::cross-filter-modules :<- [::state] (fn [s _] (:cross-filter-modules s)))
(re-frame/reg-sub ::cross-filter-urls :<- [::state] (fn [s _] (:cross-filter-urls s)))
(re-frame/reg-sub ::cross-filter-views :<- [::state] (fn [s _] (:cross-filter-views s)))
(re-frame/reg-sub ::filter-render-mode :<- [::state] (fn [s _] (or (:filter-render-mode s) :advanced)))
(re-frame/reg-sub ::loading? :<- [::state] (fn [s _] (boolean (:loading? s))))
(re-frame/reg-sub ::saving? :<- [::state] (fn [s _] (boolean (:saving? s))))
(re-frame/reg-sub ::recomputing? :<- [::state] (fn [s _] (boolean (:recomputing? s))))
(re-frame/reg-sub ::error :<- [::state] (fn [s _] (:error s)))
(re-frame/reg-sub ::ptql-error :<- [::state] (fn [s _] (:ptql-error s)))
(re-frame/reg-sub ::auto-filter-options :<- [::state] (fn [s _] (:auto-filter-options s)))
(re-frame/reg-sub ::auto-filter-max-levels :<- [::state] (fn [s _] (:auto-filter-max-levels s)))
(re-frame/reg-sub ::auto-filter-limit-reached? :<- [::state] (fn [s _] (boolean (:auto-filter-limit-reached? s))))
(re-frame/reg-sub ::available-fields :<- [::state] (fn [s _] (:available-fields s)))
(re-frame/reg-sub ::form :<- [::state] (fn [s _] (:form s)))
(re-frame/reg-sub ::basic-builder-ast :<- [::form] (fn [f _] (:basic-builder-ast f)))
(re-frame/reg-sub ::cross-filter-entity-by-path :<- [::form] (fn [f _] (:cross-filter-entity-by-path f)))

(re-frame/reg-sub
  ::save-disabled-reason
  :<- [::form]
  :<- [::filter-render-mode]
  :<- [::ptql-error]
  (fn [[form render-mode ptql-error] _]
    (cond
      (str/blank? (:name form))
      :empty-name

      (and (= :auto-filter (:mode form))
           (empty? (remove str/blank? (:auto-filter form))))
      :no-auto-filter

      (and (= :ptql (:mode form))
           (= :basic render-mode)
           (bb/has-incomplete-clauses? (:basic-builder-ast form)))
      :incomplete

      (and (= :ptql (:mode form))
           (= :advanced render-mode)
           (some? ptql-error))
      :invalid-ptql)))

(re-frame/reg-sub
  ::cross-filter-entity-at-path
  :<- [::cross-filter-entity-by-path]
  :<- [::basic-builder-ast]
  :<- [::cross-filter-views]
  :<- [::cross-filter-modules]
  (fn [[cf-entity-by-path ast cf-views cf-modules] [_ path]]
    (or (get cf-entity-by-path path)
        (let [view-id (-> (bb/get-at ast path)
                          (bb/cross-filter-ref)
                          :view_id)]
          (or (get-in cf-views [(str view-id) :entity])
              (first cf-modules))))))
